// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, number, nullOrUndefined, boolean } from "@altostra/type-validations/lib/primitives";

export const isAppsBusinessAccountsResult = objectOf({
  accounts: objectOf({
    description: string,
    fields: arrayOf(
      objectOf({
        name: string,
        token: string,
        type: string,
      })
    ),
    name: string,
    num_items: number,
    storage_size: number,
    updated_at: nullOrUndefined,
    created_at: nullOrUndefined,
    id: string,
    import_errors: arrayOf(nullOrUndefined),
    processing: boolean,
    update_error: objectOf({}),
  }),
});
